import {emptyExternalFindings, ExternalFindings} from "../../external-findings";
import {ExternalAnalysisType} from "../../../../hospitals/edit-hospital/hospital.details";

const fieldsExcludedFromValidation: (keyof ExternalFindings)[] = ["sRuns", "vRuns"];

const casChildToParent = new Map<keyof ExternalFindings, keyof ExternalFindings>([
  ["afibTotalDuration", "afibBurden"],
  ["pausesOverThresholdLongestDuration", "pausesOverThreshold"],
  ["ventricularBeatsBurden", "ventricularBeats"],
  ["ventricularTachycardiasMaxHeartRate", "ventricularTachycardias"],
  ["ventricularTachycardiasLongestDuration", "ventricularTachycardias"],
  ["atrialBeatsBurden", "atrialBeats"],
  ["atrialTachycardiasLongestDuration", "atrialTachycardias"],
  ["atrialTachycardiasMaximumHeartRate", "atrialTachycardias"],
  ["atrialTachycardiasLongestBeats", "atrialTachycardias"],
  ["atrialTachycardiasLongestBeatsMaximumHeartRate", "atrialTachycardias"],
  ["atrialTachycardiasMaximumHeartRateDuration", "atrialTachycardias"],
  ["atrialTachycardiasMaximumHeartRateBeats", "atrialTachycardias"],
]);

const casFields: (keyof ExternalFindings)[] = [
  "afibBurden",
  "afibTotalDuration",
  "averageHeartRate",
  "minimumHeartRate",
  "maximumHeartRate",
  "pausesOverThreshold",
  "pausesOverThresholdLongestDuration",
  "ventricularBeats",
  "ventricularBeatsBurden",
  "ventricularTachycardias",
  "ventricularTachycardiasLongestDuration",
  "ventricularTachycardiasMaxHeartRate",
  "slowVentricularRhythmCount",
  "ventricularCoupletsCount",
  "atrialBeats",
  "atrialBeatsBurden",
  "atrialTachycardias",
  "atrialTachycardiasLongestBeats",
  "atrialTachycardiasLongestBeatsMaximumHeartRate",
  "atrialTachycardiasLongestDuration",
  "atrialTachycardiasMaximumHeartRate",
  "atrialTachycardiasMaximumHeartRateDuration",
  "atrialTachycardiasMaximumHeartRateBeats",
  "vRuns",
  "sRuns"
];

export function areExternalFindingsMissingFields(externalFindings: ExternalFindings, externalAnalysisType: ExternalAnalysisType) {
  return requiredFields(externalAnalysisType)
    .filter(key => isMissingField(externalFindings, externalAnalysisType, key))
    .length > 0;
}

function isMissingField(findings: ExternalFindings, type: ExternalAnalysisType, key: keyof ExternalFindings): boolean {
  if (findings[key] !== undefined) {
    return false;
  }
  if (type === "CAS") {
    const parent = casChildToParent.get(key);
    if (parent !== undefined && findings[parent] === 0) {
      return false;
    }
  }
  return true;
}

function requiredFields(externalAnalysisType: ExternalAnalysisType): (keyof ExternalFindings)[] {
  if (externalAnalysisType === "CAS") {
    return casFields;
  }
  return Object.keys(emptyExternalFindings)
    .filter((key) => !fieldsExcludedFromValidation.includes(key)) as (keyof ExternalFindings)[];
}
